module.exports = __webpack_public_path__ + "img/FLDC-alt.7bdf9051.svg";